export enum UrlPath {
    MyFavorites = "/myfavorites",
    Bookmarks = "/bookmarks",
    Auth = "/auth"
}
